/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-actions[_ngcontent-%COMP%]{position:absolute;bottom:0;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-line-pack:center;align-content:center}[_nghost-%COMP%]{display:block;position:relative;height:100%}.outerwrap[_ngcontent-%COMP%]{height:100%}.actionbar[_ngcontent-%COMP%]{margin-top:15px}.scroll[_ngcontent-%COMP%]{overflow-y:auto}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/coursedescription/coursedescription.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js